import React from "react";

function Discography() {
    return (
        <div>
            <h1>Discography section goes here!</h1>
        </div>
    )
}

export default Discography;